import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation, gql } from '@apollo/client';
import { TrackingContext } from '@vrbo/react-event-tracking';
import SubmitButton from '../../Button/SubmitButton';

export const UPDATE_CONTACT = gql`
mutation updateContact($contact: UpdatePartnerContactInput!) {
    updateContact(contact: $contact) {
        type,
        lpsContact {
            joinId
        },
        vrboContact {
            autoAuthUrl,
            userPublicUuid,
            newSupplier
        }
    }
}
`;

const MissingDetailsSubmit = (props) => {
    const {
        onCompleted,
        validPhone,
        onError,
        addPhoneToSecureListEnabled,
        duaid,
        hasPhoneNumber,
        passwordValidation,
        hasPasswordSet
    } = props;
    const { trigger } = useContext(TrackingContext);
    const [updateContact] = useMutation(UPDATE_CONTACT, { onCompleted, onError });
    const [inFlight, setInFlight] = useState(false);
    const onClick = async () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'MissingDetails: nextButton'
        });
        const {
            password,
            phoneCountryCode,
            phoneCountryCodeDigits,
            phoneNumber,
            locale,
            fingerprint
        } = props;
        setInFlight(true);
        let trustPayload = '';
        /* istanbul ignore else */
        if (typeof window === 'object') {
            trustPayload = window.trustApi.getTrustPayload();
        }

        const contact = {
            type: 'FRBO', // This is always the case for missing details.
            password: password || '',
            phoneCountryCode: phoneCountryCode || '',
            phoneCountryCodeDigits: phoneCountryCodeDigits || '',
            phoneNumber: phoneNumber || '',
            locale,
            fingerprint,
            trustPayload,
            addPhoneToSecureListEnabled,
            duaid,
            source: 'MISSING DETAILS'
        };

        await updateContact({
            variables: {
                contact
            }
        });
    };
    const {
        ctaLabel
    } = props;
    return (
        <div>
            <SubmitButton
                animated={inFlight}
                label={ctaLabel}
                onClick={onClick}
                data-wdio="submit-button"
                disabled={
                    (!validPhone && !hasPhoneNumber)
                    || (!hasPasswordSet && !passwordValidation?.isValid)}
            />
        </div>
    );
};

MissingDetailsSubmit.propTypes = {
    ctaLabel: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    phoneCountryCode: PropTypes.string.isRequired,
    phoneCountryCodeDigits: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
    hasPhoneNumber: PropTypes.bool.isRequired,
    validPhone: PropTypes.bool.isRequired,
    locale: PropTypes.string.isRequired,
    onError: PropTypes.func.isRequired,
    onCompleted: PropTypes.func.isRequired,
    fingerprint: PropTypes.shape({
        orgId: PropTypes.string,
        deviceId: PropTypes.string
    }).isRequired,
    addPhoneToSecureListEnabled: PropTypes.bool.isRequired,
    duaid: PropTypes.string.isRequired,
    hasPasswordSet: PropTypes.bool.isRequired,
    passwordValidation: PropTypes.shape({
        isValid: PropTypes.bool.isRequired,
        error: PropTypes.string
    }).isRequired
};

export default MissingDetailsSubmit;
